// สถานะของบล็อกในหน้า Overview: กำลังโหลด / บอกเหตุที่ยังไม่มีข้อมูล
import type { ReactNode } from "react";

export function OvLoading() {
  return <div className="ov-loading">กำลังโหลด…</div>;
}

/** ข้อความอธิบายในกรอบ panel — ใช้ตอนยังไม่ได้ผูก/ยังไม่ login/ดึงไม่สำเร็จ */
export function OvNote({ children }: { children: ReactNode }) {
  return (
    <div className="panel">
      <p className="muted">{children}</p>
    </div>
  );
}
